import { Separator } from "@/components/ui/separator";
import Header from "./components/header";
import ProfileSettings from "./components/profile-settings";
import LanguageSettings from "./components/language-settings";
import Syncronization from "./components/syncronization";
import LogoutButton from "./components/logout-button";
import SubscriptionInfo from "./components/subscription-info";
import { useTranslation } from "react-i18next";

const More = () => {
  const { t } = useTranslation();

  return (
    <>
      <title>{t("title.more")}</title>
      <div>
        <Header />
        <Separator className="mt-[21px]" />
        <SubscriptionInfo />
        <Separator />
        <ProfileSettings />
        <Separator />
        <LanguageSettings />
        <Separator />
        <Syncronization />
        <Separator />
        <LogoutButton />
        <Separator />
      </div>
    </>
  );
};

export default More;
